import { render } from "./product-recommendations.vue?vue&type=template&id=7a65b284"
import script from "./product-recommendations.vue?vue&type=script&lang=js"
export * from "./product-recommendations.vue?vue&type=script&lang=js"

import "./product-recommendations.vue?vue&type=style&index=0&id=7a65b284&lang=scss"

import exportComponent from "/Users/connoringold/Documents/projects/bao/toteme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__